import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ReturnPageName from '../ReturnPageName';
import ReturnPageDirectory from '../ReturnPageDirectory';



export default function InspectionBreadcrumbs(props) {
    const [pageDirectoryList, setPageDirectoryList] = React.useState([])
    const pathName = useLocation().pathname;
    React.useEffect(() => {
        const pageDirectory = ReturnPageDirectory(pathName);
        setPageDirectoryList(pageDirectory.map(path => ({
            pathName: path,
            pageName: ReturnPageName(path)
        })));
    }, [])

    React.useEffect(() => {
    }, [pageDirectoryList])


    if (props.visible === false) return null;

    return (
        <Breadcrumbs separator={<span style={{ fontWeight: 'bold', color: '#aaaaaa' }}>{'>'}</span>}
            aria-label="breadcrumb" sx={{ mb: 2 }}>
            {pageDirectoryList.map((page, index) => {
                return (
                    page.pathName === pathName ?
                        <Typography
                            sx={{ color: 'text.primary' }}
                            key={index}>
                            {page.pageName}
                        </Typography>
                        :
                        <Link
                            key={index}
                            underline="always"
                            color="primary"
                            href={page.pathName}
                        >
                            {page.pageName}
                        </Link>
                )
            })}
        </Breadcrumbs>
    );
}